import { AbilityBuilder, Ability } from '@casl/ability'

import Passenger from '@/models/passenger'

export default function getAbilitiesFor(passenger: Passenger): Ability {
  return AbilityBuilder.define(
    { subjectName: () => 'Passenger' },
    (can: any, cannot: any) => {
      cannot('update', 'Passenger') // temporarily disabled ability to update customers
      if (passenger.canBeChanged) {
        can('delete', 'Passenger')
        can('invite', 'Passenger')
      }
    },
  )
}
